'use strict';
var isArray = require('../utils/is-array'),
    keys = require('../utils/get-keys');

/**
 * A child definition class for the ImmobliareFlux components
 *
 * A child could be defined as:
 *  - Component, if defined in the component @param
 *  - ComponentList, if defined as array of classes in the component @param
 *  - State, if defined in the states @param
 *
 * @param {Object} components
 * @param {Object} states
 * @constructor
 */
function ChildDefinition(components, states) {
    this._init(components, states);
}

ChildDefinition.prototype =  {
    /**
     * The initializer of the class
     *
     * @param {Object} components
     * @param {Object} states
     * @private
     */
    _init: function (components, states) {
        this.components = components;
        this.states = states;
    },

    /**
     * Checks if this definition has components.
     *
     * @returns {boolean}
     */
    hasComponents: function () {
        var prop;

        for (prop in this.components) {
            if (this.components.hasOwnProperty(prop)) {
                return true;
            }
        }

        return false;
    },

    /**
     * Checks if the child defined with this @param name is a Component
     *
     * @param {string} name
     * @returns {boolean}
     */
    isComponent: function (name) {
        return !!this.components[name];
    },

    /**
     * Checks if the child defined with this @param name is a State
     *
     * @param {string} name
     * @returns {boolean}
     */
    isState: function (name) {
        return !!this.states[name];
    },

    /**
     * Checks if the child defined with this @param name is a ComponentList
     *
     * @param {string} name
     * @returns {boolean}
     */
    isComponentList: function (name) {
        return isArray(this.components[name]);
    },

    /**
     * Checks if there is a child defined with @param name
     *
     * @param {string} name
     * @returns {boolean}
     */
    isDefined: function (name) {
        return this.isComponent(name) || this.isState(name);
    },

    /**
     * Returns the class of the child defined with @param name
     *
     * @param {string} name
     * @returns {*}
     */
    getComponentClass: function (name) {
        if (this.isComponent(name)) {
            if (this.isComponentList(name)) {
                return this.components[name][0];
            } else {
                return this.components[name];
            }
        }

        return false;
    },

    /**
     * @returns {array} The list of the childs names
     */
    getComponentsNames: function () {
        return keys(this.components);
    },

    /**
     * @returns {Object} The defined states
     */
    getStates: function () {
        return this.states;
    }
};

module.exports = ChildDefinition;

